import { setupAgGridLicence } from '@sgme/aggrid';
import { ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';
import { AllEnterpriseModule } from 'ag-grid-enterprise';
ModuleRegistry.registerModules([AllEnterpriseModule]);

provideGlobalGridOptions({
  theme: 'legacy',
});

setupAgGridLicence();
